<div class="bp-modal mod-lg">
  @if (!showMandate) {
    <bp-modal-header class="font-semibold" title="{{ 'mandate_list_modal_title' | translate }}">
      <a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
    </bp-modal-header>
    <div class="mandate_list__wrapper" [ngClass]="{ 'mod-empty': showEmptySection }">
      @if (showEmptySection) {
        {{ "no_active_sepa_mandates" | translate }}
      } @else {
        @for (account of sepaAccounts$ | async; track account) {
          <div
            class="mandate_list__item"
            (click)="openMandate(account)">
            <div class="mandate_list__item__column">
              <span class="large-weight font-size-17 mandate_list__item__iban">{{
                account?.getShortId()
              }}</span>
              <span class="mandate_list__item__label">
                {{
                (account?.getIsDeleted() ? "mandate_revoked_label" : "mandate_active_label") | translate
                }}
              </span>
            </div>
            <div class="mandate_list__item__column mod-spacer">
              <span class="font-size-12 text-gray">{{ "creation_date_mandate_list_label" | translate }}</span>
              <span class="font-size-15">{{
                account?.getCreationTime().getDate() | bp_date: { time: [] }
              }}</span>
            </div>
            <div class="mandate_list__item__column">
              <span class="font-size-12 text-gray">{{ "iban_primary_field" | translate }}</span>
              <span class="font-size-15 mod-iban">{{ account?.bankAccountDetails?.getIban() }}</span>
            </div>
          </div>
        }
      }
    </div>
  }
  @if (showMandate) {
    <confirm-mandate-modal
      [bankAccount]="bankAccount"
      [showBackButton]="showBackButton"
      [readonly]="true"
    (buttonClick)="onButtonClick($event)"></confirm-mandate-modal>
  }
</div>
